class PriceRangeSlider extends HTMLElement {
  connectedCallback() {
    this.minSlider = this.querySelector('.price-range-slider__input--min');
    this.maxSlider = this.querySelector('.price-range-slider__input--max');
    this.rangeEl   = this.querySelector('.price-range-slider__range');

    if (!this.minSlider || !this.maxSlider || !this.rangeEl) return;

    this.minTextInput = document.getElementById(this.dataset.minInputId);
    this.maxTextInput = document.getElementById(this.dataset.maxInputId);

    // Native inputs stop catching pointer events entirely — we drive
    // dragging ourselves from the container, so overlap can never hide a thumb.
    this.minSlider.style.pointerEvents = 'none';
    this.maxSlider.style.pointerEvents = 'none';

    this.activeSlider = null;

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp   = this.onPointerUp.bind(this);
    this.onKeyboardInput = this.onKeyboardInput.bind(this);
    this.onCommit = this.onCommit.bind(this);

    this.addEventListener('pointerdown', this.onPointerDown);

    // Keyboard (arrow keys) still works natively on a focused input
    // even with pointer-events:none, so keep syncing on 'input'/'change'.
    this.minSlider.addEventListener('input', this.onKeyboardInput);
    this.maxSlider.addEventListener('input', this.onKeyboardInput);
    this.minSlider.addEventListener('change', this.onCommit);
    this.maxSlider.addEventListener('change', this.onCommit);

    requestAnimationFrame(() => {
      this.updateRangeStyle();
      this.updateDisplay(
        parseInt(this.minSlider.value, 10),
        parseInt(this.maxSlider.value, 10)
      );
    });
  }

  valueFromEvent(e) {
    const rect = this.getBoundingClientRect();
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    let percent = (clientX - rect.left) / rect.width;
    percent = Math.max(0, Math.min(1, percent));

    const min  = parseFloat(this.minSlider.min);
    const max  = parseFloat(this.minSlider.max);
    const step = parseFloat(this.minSlider.step) || 1;

    let value = min + percent * (max - min);
    return Math.round(value / step) * step;
  }

  onPointerDown(e) {
    const value  = this.valueFromEvent(e);
    const minVal = parseFloat(this.minSlider.value);
    const maxVal = parseFloat(this.maxSlider.value);

    // Whichever thumb is numerically closer to where you clicked wins —
    // not whichever happened to be visually on top.
    this.activeSlider =
      Math.abs(value - minVal) <= Math.abs(value - maxVal)
        ? this.minSlider
        : this.maxSlider;

    this.activeSlider.focus();
    this.setPointerCapture?.(e.pointerId);

    this.addEventListener('pointermove', this.onPointerMove);
    this.addEventListener('pointerup', this.onPointerUp);
    this.addEventListener('pointercancel', this.onPointerUp);

    this.updateFromPointer(e);
  }

  onPointerMove(e) {
    this.updateFromPointer(e);
  }

  onPointerUp() {
    this.removeEventListener('pointermove', this.onPointerMove);
    this.removeEventListener('pointerup', this.onPointerUp);
    this.removeEventListener('pointercancel', this.onPointerUp);
    this.onCommit();
    this.activeSlider = null;
  }

  updateFromPointer(e) {
    if (!this.activeSlider) return;

    let value  = this.valueFromEvent(e);
    let minVal = parseFloat(this.minSlider.value);
    let maxVal = parseFloat(this.maxSlider.value);

    if (this.activeSlider === this.minSlider) {
      value = Math.min(value, maxVal);
      this.minSlider.value = value;
      minVal = value;
    } else {
      value = Math.max(value, minVal);
      this.maxSlider.value = value;
      maxVal = value;
    }

    if (this.minTextInput) this.minTextInput.value = minVal;
    if (this.maxTextInput) this.maxTextInput.value = maxVal;

    this.updateRangeStyle();
    this.updateDisplay(minVal, maxVal);
  }

  // Handles native keyboard-driven changes (arrow keys on a focused input)
  onKeyboardInput(e) {
    const target = e.target;
    let minVal = parseInt(this.minSlider.value, 10);
    let maxVal = parseInt(this.maxSlider.value, 10);

    if (target === this.minSlider && minVal > maxVal) {
      this.minSlider.value = maxVal;
      minVal = maxVal;
    } else if (target === this.maxSlider && maxVal < minVal) {
      this.maxSlider.value = minVal;
      maxVal = minVal;
    }

    if (this.minTextInput) this.minTextInput.value = minVal;
    if (this.maxTextInput) this.maxTextInput.value = maxVal;

    this.updateRangeStyle();
    this.updateDisplay(minVal, maxVal);
  }

onCommit() {
  if (this.minTextInput) {
    this.minTextInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
  if (this.maxTextInput) {
    this.maxTextInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  // Price set hote hi poora filter drawer band karo — X button click jaisa
  const closeButton = document.querySelector('.mobile-facets__close-button');
  if (closeButton) closeButton.click();
}

  updateRangeStyle() {
    const min    = parseFloat(this.minSlider.min) || 0;
    const max    = parseFloat(this.minSlider.max) || 1;
    const minVal = parseFloat(this.minSlider.value) || 0;
    const maxVal = parseFloat(this.maxSlider.value) || 0;

    const range = max - min || 1;

    let leftPercent  = ((minVal - min) / range) * 100;
    let rightPercent = ((maxVal - min) / range) * 100;

    leftPercent  = Math.max(0, Math.min(100, leftPercent));
    rightPercent = Math.max(0, Math.min(100, rightPercent));

    this.rangeEl.style.left  = leftPercent + '%';
    this.rangeEl.style.width = (rightPercent - leftPercent) + '%';
    this.rangeEl.style.right = 'auto';
  }

  updateDisplay(minVal, maxVal) {
    const currency = this.dataset.currency || '';
    const wrapper = this.closest('.custom-price-filter');
    if (!wrapper) return;

    const minDisplay = wrapper.querySelector('.custom-price-filter__value--min');
    const maxDisplay = wrapper.querySelector('.custom-price-filter__value--max');

    if (minDisplay) minDisplay.textContent = currency + minVal;
    if (maxDisplay) maxDisplay.textContent = currency + maxVal;
  }
}

if (!customElements.get('price-range-slider')) {
  customElements.define('price-range-slider', PriceRangeSlider);
}